// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';

  const getEventPageX = (e) => {
    if (e.type === 'touchmove') {
      return e.originalEvent.touches[0].pageX;
    }
    return e.pageX;
  };

  $('#oc-container .card__more').each((key, item) => {
    const $item = $(item);
    const $card = $item.closest('.card');
    const $description = $card.find('.overlay__description');

    const toggleOverlay = () => {
      $card.toggleClass('card--content-expanded');
      if ($description.attr('aria-hidden') === 'true') {
        $description.attr('aria-hidden', 'false');
      } else {
        $description.attr('aria-hidden', 'true');
      }
    };

    $item.on('click', toggleOverlay);
  });

  let compareCardWidth;
  const initCompareTool = ($item, $overlay, $slider) => {
    compareCardWidth = $item.width();

    $overlay.css('width', `${compareCardWidth / 2}px`);
    $slider.css(
      isRTL ? 'right' : 'left',
      `${compareCardWidth / 2 - $slider.width() / 2}px`
    );
  };
  $('#oc-container .card__compare').each((key, item) => {
    const $item = $(item);
    const $overlay = $item.find('.compare__img--overlay');
    const $slider = $item.find('.compare__slider');
    const $handle = $item.find('.compare__handle');

    initCompareTool($item, $overlay, $slider);
    $slider.css('display', 'flex');

    const getCursorPos = (e) => {
      let x = 0;
      const event = e || window.event;

      const a = $overlay.offset();
      const aLeft = isRTL ? a.left + $overlay.width() : a.left;
      x = getEventPageX(event) - aLeft;
      x -= window.pageXOffset;
      return x;
    };

    const slide = (x) => {
      $overlay.css('width', `${x}px`);
      $slider.css(
        isRTL ? 'right' : 'left',
        `${$overlay.width() - $slider.width() / 2}px`
      );
    };

    const dragMove = (e) => {
      let pos = Math.abs(getCursorPos(e));
      if (pos < 0) {
        pos = 0;
      } else if (pos > compareCardWidth) {
        pos = compareCardWidth;
      }

      slide(pos);
    };

    const dragStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.handleClickTracking($(e.target));
      $item.on('mousemove touchmove', dragMove);
    };
    const dragEnd = () => {
      $item.off('mousemove touchmove', dragMove);
    };

    $handle.on('mousedown touchstart', dragStart);
    $item.on('mouseup touchend mouseleave', dragEnd);
  });

  $('#oc-container .card__zoom').each((key, item) => {
    const $image = $(item).find('.picture-container');
    const $slider = $(item).find('.zoom__slider');
    const $handle = $(item).find('.zoom__handle');
    let sliderWidth;
    let sliderLeft;

    $handle.css(
      'transform',
      `translateX(${isRTL ? '' : '-'}${$handle.width() / 2}px)`
    );

    const dragMove = (e) => {
      const pageX = getEventPageX(e);
      if (pageX >= sliderLeft && pageX <= sliderLeft + sliderWidth) {
        const handleTempValue = pageX - sliderLeft - $handle.width() / 2;
        const handleValue = isRTL
          ? handleTempValue - (sliderWidth - $handle.width())
          : handleTempValue;
        $handle.css('transform', `translateX(${handleValue}px)`);
        const tempValue = (pageX - sliderLeft) / sliderWidth;
        const value = isRTL ? 1 - tempValue : tempValue;
        $image.css(
          'transform',
          `translate3d(${isRTL ? '0' : '-50%'}, -50%, 0) scale(${
            0.5 * (1 - value) + 1 * value
          })`
        );
      }
    };

    const dragStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.handleClickTracking($(e.target));

      sliderWidth = $slider.width();
      sliderLeft = $slider.offset().left;
      $(item).on('mousemove touchmove', dragMove);
    };
    const dragEnd = () => {
      $(item).off('mousemove touchmove', dragMove);
    };

    $handle.on('mousedown touchstart', dragStart);
    $(item).on('mouseup touchend mouseleave', dragEnd);
  });

  $('#oc-container .card__toggle').each((key, item) => {
    const $overlay = $(item).find('.toggle__img--overlay');
    const $toggle = $(item).find('.toggle__button');
    const $toggleText = $(item).find('.toggle__text');

    const toggleAI = () => {
      $overlay.toggleClass('is-visible');
      if ($overlay.hasClass('is-visible')) {
        $toggleText.text($toggleText.data('text-on'));
      } else {
        $toggleText.text($toggleText.data('text-off'));
      }
    };

    $toggle.on('click', toggleAI);
  });

  let currentMedia = 'sm';
  const $videoCards = $('#oc-container .card__video');
  const setVideos = () => {
    const w = $(window).width();
    let newMedia = currentMedia;

    if (w >= 1440 && currentMedia !== 'xl') {
      newMedia = 'xl';
    } else if (w >= 1024 && w < 1439 && currentMedia !== 'lg') {
      newMedia = 'lg';
    } else if (w >= 768 && w < 1023 && currentMedia !== 'md') {
      newMedia = 'md';
    } else if (w < 768 && currentMedia !== 'sm') {
      newMedia = 'sm';
    }

    if (newMedia !== currentMedia) {
      currentMedia = newMedia;
      $videoCards.each((key, item) => {
        const $video = $(item).find('video');
        if ($video.length) {
          $video.attr('src', $video.data(`src-${currentMedia}`));
          $video[0].load();
        }
      });
    }
  };

  const resetCompareTools = () => {
    $('#oc-container .card__compare').each((key, item) => {
      const $item = $(item);
      const $overlay = $item.find('.compare__img--overlay');
      const $slider = $item.find('.compare__slider');
      initCompareTool($item, $overlay, $slider);
    });
  };

  // Play videos with intersection observer
  $('.card video[autoplay]').observe(
    (evt) => {
      const el = evt[0].target;
      if (evt[0].isIntersecting) {
        el.play();
      } else {
        el.pause();
      }
    },
    { threshold: 0.75 }
  );

  setVideos();
  $(window).on('resize', () => {
    setVideos();
    resetCompareTools();
  });
});
